import React, { useEffect } from 'react';
import {Link} from 'react-router-dom';
// import axios from 'axios';
import {useSelector, useDispatch} from 'react-redux';
import { listProducts } from '../../actions/productActions';

function HomePage (props) {

    // const [products, setProduct] = useState([]);
    const productList = useSelector(state => state.productList);
    const { products, loading, error} = productList;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(listProducts());

        return () => {    
        };
    }, [dispatch] );

    return loading? <div>Loading...</div> :
    error? <div>{error}</div> :
    <ul className="products">
        { products && products.map(product =>
            <li key={product._id}>
                <div className="product">
                    <Link to = {'/product/' + product._id}><img className ="product-img" src={product.image} alt="product"/></Link>
                    <div className= "product-name">
                        <Link to= {'/product/'+ product._id}>{product.name}</Link>
                    </div>
                    <div className= "product-artist"> {product.artist}</div>
                    <div>{product.category}</div>
                    <div className= "price">€{product.price}</div>
                </div>
            </li>) 
        }
     </ul>

}

export default HomePage